import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

const NoAccessView = () => {
  return (
    <Card variant="outlined">
      <CardContent sx={{ padding: 5 }}>
        <Stack
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <Typography variant="caption">
            You do not have permission to access this workflow.
          </Typography>
        </Stack>
      </CardContent>
    </Card>
  );
};

export default NoAccessView;
